import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().email('正しいメールアドレスを入力してください'),
  password: z.string().min(1, 'パスワードを入力してください'),
})

export const updateProfileSchema = z.object({
  lastName: z
    .string()
    .min(1, '苗字を入力してください')
    .max(50, '苗字は50文字以内で入力してください'),
  firstName: z
    .string()
    .min(1, '名前を入力してください')
    .max(50, '名前は50文字以内で入力してください'),
  lastNameKana: z
    .string()
    .min(1, '苗字のフリガナを入力してください')
    .max(50, '苗字のフリガナは50文字以内で入力してください'),
  firstNameKana: z
    .string()
    .min(1, '名前のフリガナを入力してください')
    .max(50, '名前のフリガナは50文字以内で入力してください'),
  tel: z
    .string()
    .min(1, '電話番号を入力してください')
    .regex(
      /^0\d{9,10}$/,
      '正しい電話番号を入力してください（例: 09012345678）'
    ),
})
